import { useState } from 'react'
import Header from '../../../../customs/Header'
import ZoneContent from './ZoneContent';
import SettingsModal from '../Modal/settingsCustomModal';
import CreateZone from './CreateZone';

export default function Main() {
  const [createZone, setCreateZone] = useState(false);

  const handleOpenCreateZone = () => setCreateZone(true);
  const handleCloseCreateZone = () => setCreateZone(false);

  return (
    <section>
      <Header props={
      { 
        firstName: 'All', 
        secondName: 'Zones', 
        buttonText: 'Create Zone', 
      }}
      handleOpen={handleOpenCreateZone}
    />

    <ZoneContent />
    
    <SettingsModal 
      open={createZone}
      cancel={handleCloseCreateZone}
      maxWidth='480px'
      header={'Create Zone'}
      showrightIcon={false}
      content={<CreateZone handleClose={handleCloseCreateZone}/>}
    />
    </section>
    
  )
}

